<template>
    <font-awesome-icon icon="caret-down" />
</template>

<script>
export default {
    name: "LOpenIndicator"
};
</script>